import { useCallback } from 'react';
import { chatListFamily } from '../states/chat';
import { useAtomCallback } from 'jotai/utils';
import { useAtomValue } from 'jotai';
import { ChatType } from '../components/chat-list-section/chat-row/typings';
import { selectedChatIdsListAtom } from '../states/chat-list';

export const useSelectedChatsIncludeTypes = (types: ChatType[]) => {
  const selectedChatIdsList = useAtomValue(selectedChatIdsListAtom);
  return useAtomCallback(
    useCallback(
      (get) => {
        return selectedChatIdsList.some((chatID) => {
          const chatType = get(chatListFamily({ id: chatID }))?.chatType;
          return chatType && types.includes(chatType);
        });
      },
      [selectedChatIdsList, types]
    )
  );
};
